export default __webpack_public_path__ + "static/media/airstrapz-cbb-banner-3.a125884c.jpg";